:host {
  display: inline-block;
  width: 1.5ex;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
}
#dot {
  display: inherit;
  width: inherit;
  aspect-ratio: inherit;
  border-radius: inherit;
}
